import Vue from 'vue'
import Vuex from 'vuex'
import RevenuesService from '../../services/RevenuesService'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    filters: {
      currency: 'nzd',
      dateRange: {
        startDate: Vue.moment().startOf('month').format('YYYY-MM-DD'),
        endDate: Vue.moment().endOf('month').format('YYYY-MM-DD')
      }
    },
    data: {
      page: '',
      per_page: 100,
      splits: [],
      total_count: ''
    },
    totals: {},
    pagination: {
      perPage: 50,
      activePage: 1
    }
  },
  mutations: {
    setFilterCurrency (state, currency) {
      state.filters.currency = currency
    },
    setFilterDateRange (state, range) {
      state.filters.dateRange.startDate = Vue.moment(range.startDate).format('YYYY-MM-DD')
      state.filters.dateRange.endDate = Vue.moment(range.endDate).format('YYYY-MM-DD')
    },
    setTotals (state, totals) {
      state.totals = totals
    },
    setData (state, data) {
      state.data = data
    },
    setPaginationPerPage (state, data) {
      state.pagination.perPage = data
    },
    setPaginationActivePage (state, data) {
      state.pagination.activePage = data
    }
  },
  actions: {
    loadSplits ({commit, state}, trainerId) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true, { root: true })
        let splitService = new RevenuesService()
        splitService
          .getTrainerWise(trainerId, {
            'currency': state.filters.currency,
            'page': state.pagination.activePage,
            'start_date': state.filters.dateRange.startDate,
            'end_date': state.filters.dateRange.endDate,
            'per_page': state.pagination.perPage
          })
          .then((res) => {
            commit('setData', res.data)
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {
            commit('setLoading', false, { root: true })
          })
      })
    },
    loadSplitTotals ({commit, state}, trainerId) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true, { root: true })
        let splitService = new RevenuesService()
        splitService
          .getTrainerWiseTotals(trainerId, {
            'currency': state.filters.currency,
            'start_date': state.filters.dateRange.startDate,
            'end_date': state.filters.dateRange.endDate
          })
          .then((res) => {
            commit('setTotals', res.data.totals)
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {
            commit('setLoading', false, { root: true })
          })
      })
    }
  },
  getters: {
    getFilterCurrency (state) {
      return state.filters.currency
    },
    getFilterDateRange (state) {
      return state.filters.dateRange
    },
    getSplitsTotals (state) {
      return state.totals
    },
    getSplits (state) {
      return state.data.splits
    },
    getSplitsTotalCount (state) {
      return state.data.total_count
    },
    getPaginationCurrentPage (state) {
      return state.pagination.activePage
    },
    getPaginationPerPage (state) {
      return state.pagination.perPage
    }
  }
}
